import styled from 'styled-components'

export const TricolorOuter = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-sizing: border-box;
`

export const TricolorWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  box-sizing: border-box;
  display: flex;
  @media only screen and (max-width: 1055px) {
    display: block;
  }
  @media only screen and (max-width: 1055px) {
    padding: 0;
`

export const TricolorCard = styled.div`
  padding: 2rem 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 430px;

  color: white;
  > h3 {
    font-size: 28px;
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: 2rem;
    white-space: pre-line;
  }
  &:nth-child(1) {
    background-color: ${({ theme }) => theme.colors.tricolor1};
  }
  &:nth-child(2) {
    background-color: ${({ theme }) => theme.colors.tricolor2};
    margin: 0 10px;
  }
  &:nth-child(3) {
    background-color: ${({ theme }) => theme.colors.tricolor3};
  }

  @media only screen and (max-width: 1055px) {
    margin-bottom: 2rem;
    &:nth-child(2) {
      margin: 0 0 2rem 0;
    }
  }
  @media only screen and (max-width: 600px) {
    width: 100vw;
    margin: 0;
    &:nth-child(2) {
      margin: 0;
    }
  }
`

export const Bullets = styled.ul`
  padding-bottom: 1rem;
  @media only screen and (max-width: 1055px) {
      display: flex;
      flex-direction: column;
    }
  }
`

export const Bullet = styled.li`
  > p {
    font-size: 19px;
    max-width: 250px;
    text-align: left;
    font-weight: 400;
    line-height: 1.3;
  }
  display: inline-flex;
  padding: 0 26px;
  align-items: center;
  .people {
    height: 80px;
    width: 80px;
    @media only screen and (max-width: 500px) {
      height: 60px;
      width: 60px;
    }
  }
  &:nth-child(2) {
    margin: 44px 0;
  }
`

export const IconWrapper = styled.div`
  margin-right: 2rem;
  width: 70px;
  height: 70px;
  > svg {
    width: 60px;
    height: 60px;
  }
`
